import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FaApple, FaFacebook, FaGooglePlay, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import { RxInstagramLogo } from 'react-icons/rx';
import qrimage from "../Images/jetpack-qr-code.png";

const Footer = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [open, setOpen] = useState(false);
    const [openone, setOpenone] = useState(false);
    const [opentwo, setOpentwo] = useState(false);
    const [openthree, setOpenthree] = useState(false);
    const [openFour, setOpenFour] = useState(false);
    const [openFive, setOpenFive] = useState(false);
    const [openSix, setOpenSix] = useState(false);
    const [openSeven, setOpenSeven] = useState(false);
    const [openEight, setOpenEight] = useState(false);
    const [openNine, setOpenNine] = useState(false);
    const [openTen, setOpenTen] = useState(false);
    const [openParent, setOpenParent] = useState(false);
    const [openParentTwo, setOpenParentTwo] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const toggleExpandedteo = () => {
        setOpen(!open);
    };

    const toggleExpandedone = () => {
        setOpenone(!openone);
    };

    const toggleExpandedtwo = () => {
        setOpentwo(!opentwo);
    };
    const toggleExpandedthree = () => {
        setOpenthree(!openthree);
    };
    const toggleExpandedfour = () => {
        setOpenFour(!openFour);
    };

    const toggleExpandedfive = () => {
        setOpenFive(!openFive);
    };

    const toggleExpandedsix = () => {
        setOpenSix(!openSix);
    };
    const toggleReadMore = () => {
        setOpenSeven(!openSeven);
    };
    const toggleReadMoretwo = () => {
        setOpenEight(!openEight);
    };

    const toggleReadMorethree = () => {
        setOpenNine(!openNine);
    };

    const toggleReadMorefour = () => {
        setOpenTen(!openTen);
    };
    const toggleExpandedParent = () => {
        setOpenParent(!openParent);
    };
    const toggleExpandedParenttwo = () => {
        setOpenParentTwo(!openParentTwo);
    };
    return (
        <>
            <Container fluid className='p-0'>
                <Row className="p-0">
                    <Col md={2} className="mb-4">
                        <h5 className="categoryFooter">MX Original</h5>
                        <ul className="footer_ul p-0 m-0">
                            <li className="text-white fs-13">Aashram</li>
                            <li className="text-white fs-13">Indori Ishq</li>
                            {openParent && (
                                <>
                                    <li className="text-white fs-13">Campus Diaries</li>

                                    {isExpanded && (
                                        <>
                                            <li className="text-white fs-13">Bhaukaal</li>
                                            <li className="text-white fs-13">Shiksha Mandal</li>
                                            <li className="text-white fs-13">Roohaniyat</li>
                                            <li className="text-white fs-13">Matsya Kaand</li>
                                            <li className="text-white fs-13">Hello Mini</li>
                                        </>
                                    )}
                                </>
                            )}
                        </ul>
                        {openParent && (
                            <span onClick={toggleExpanded} className="viewMore">
                                {isExpanded ? "View Less" : "View All"} {isExpanded ? <IoChevronUp /> : <IoChevronDown />}
                            </span>
                        )}
                    </Col>

                    <Col md={2} className="mb-4">
                        <h5 class="categoryFooter">Movies by Language</h5>
                        <ul className="footer_ul p-0 m-0">
                            <li className='text-white fs-13'>Hindi Movies</li>
                            <li className='text-white fs-13'>Tamil Movies</li>
                            {openParent && (
                                <>
                                    <li className='text-white fs-13'>Telugu Movies</li>

                                    {open && (
                                        <>
                                            <li className='text-white fs-13'>Punjabi Movies</li>
                                            <li className='text-white fs-13'>Bhojpuri Movies</li>
                                            <li className='text-white fs-13'>Kannada Movies</li>
                                            <li className='text-white fs-13'>Marathi Movies</li>
                                            <li className='text-white fs-13'>English Movies</li>
                                        </>
                                    )}
                                </>
                            )}
                        </ul>
                        {openParent && (
                            <span onClick={toggleExpandedteo} className="viewMore">
                                {open ? 'View Less' : 'View All'} {open ? <IoChevronUp /> : <IoChevronDown />}
                            </span>
                        )}
                    </Col>
                    <Col md={2} className="mb-4">
                        <h5 class="categoryFooter">Movies by Genre</h5>
                        <ul className='footer_ul p-0 m-0'>
                            <li className='text-white fs-13'>Crime Movies</li>
                            <li className='text-white fs-13'>Action Movies</li>
                            {openParent && (
                                <>
                                    <li className='text-white fs-13'>Romance Movies</li>

                                    {openone && (
                                        <>
                                            <li className='text-white fs-13'>Comedy Movies</li>
                                            <li className='text-white fs-13'>Horror Movies</li>
                                            <li className='text-white fs-13'>Animation Movies</li>
                                            <li className='text-white fs-13'>Thriller Movies</li>
                                            <li className='text-white fs-13'>Mystery Movies</li>
                                        </>

                                    )}
                                </>
                            )}
                        </ul>
                        {openParent && (
                            <span onClick={toggleExpandedone} className="viewMore">
                                {openone ? 'View Less' : 'View All'} {openone ? <IoChevronUp /> : <IoChevronDown />}
                            </span>
                        )}
                    </Col>
                    <Col md={2} className="mb-4">
                        <h5 class="categoryFooter">Down the Lane</h5>
                        <ul className='footer_ul p-0 m-0'>
                            <li className='text-white fs-13'>2024 Hindi Movies</li>
                            <li className='text-white fs-13'>2023 Web Series</li>
                            {openParent && (
                                <>
                                    <li className='text-white fs-13'>2023 Movies</li>

                                    {opentwo && (
                                        <>
                                            <li className='text-white fs-13'>2020 English Movies</li>
                                            <li className='text-white fs-13'>2021 Movies</li>
                                            <li className='text-white fs-13'>2022 Movies</li>
                                            <li className='text-white fs-13'>2018 Hindi Movies</li>
                                            <li className='text-white fs-13'>2018 Movies</li>
                                        </>
                                    )}
                                </>
                            )}

                        </ul>
                        {openParent && (
                            <span onClick={toggleExpandedtwo} className="viewMore">
                                {opentwo ? 'View Less' : 'View All'} {opentwo ? <IoChevronUp /> : <IoChevronDown />}
                            </span>
                        )}
                    </Col>
                    <Col md={2} className="mb-4">
                        <h5 class="categoryFooter">New Shows</h5>
                        <ul className='footer_ul p-0 m-0'>
                            <li className='text-white fs-13'>Chacha Vidhayak Hain Humare</li>
                            <li className='text-white fs-13'>Half Love Half Arranged</li>
                            {openParent && (
                                <>
                                    <li className='text-white fs-13'>Highway Love</li>

                                    {openthree && (
                                        <>
                                            <li className='text-white fs-13'>Tujhpe Main Fida</li>
                                            <li className='text-white fs-13'>Naam Namak Nishan</li>
                                            <li className='text-white fs-13'>Jamnapaar</li>
                                            <li className='text-white fs-13'>Physics Wallah</li>
                                            <li className='text-white fs-13'>Crushed</li>
                                        </>
                                    )}
                                </>
                            )}
                        </ul>
                        {openParent && (
                            <span onClick={toggleExpandedthree} className="viewMore">
                                {openthree ? 'View Less' : 'View All'} {openthree ? <IoChevronUp /> : <IoChevronDown />}
                            </span>
                        )}
                    </Col>

                    <Col md={2} className="mb-4">
                        <h5 class="categoryFooter">International Shows</h5>
                        <ul className='footer_ul p-0 m-0'>
                            <li className='text-white fs-13'>My Home My Destiny</li>
                            <li className='text-white fs-13'>Day Dreamer</li>
                            {openParent && (
                                <>
                                    <li className='text-white fs-13'>Chasing Ball</li>

                                    {openFour && (
                                        <>
                                            <li className='text-white fs-13'>Suspicious Partner</li>
                                            <li className='text-white fs-13'>I m not a Robot</li>
                                            <li className='text-white fs-13'>Goblin: The Lonely And Great God</li>
                                            <li className='text-white fs-13'>Playful Kiss</li>
                                            <li className='text-white fs-13'>Legally Romance</li>
                                        </>
                                    )}
                                </>
                            )}
                        </ul>
                        {openParent && (
                            <span onClick={toggleExpandedfour} className="viewMore">
                                {openFour ? 'View Less' : 'View All'} {openFour ? <IoChevronUp /> : <IoChevronDown />}
                            </span>
                        )}
                    </Col>
                    {openParent && (
                        <>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">Shows by Genrs</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>Romantic Web Series</li>
                                    <li className='text-white fs-13'>Thriller Web Series</li>
                                    {openParent && (
                                        <>
                                            <li className='text-white fs-13'>Comedy Web Series</li>

                                            {openFive && (
                                                <>
                                                    <li className='text-white fs-13'>Drama Web Series</li>
                                                    <li className='text-white fs-13'>Crime Web Series</li>
                                                    <li className='text-white fs-13'>Horror Web Series</li>
                                                    <li className='text-white fs-13'>Action Web Series</li>
                                                    <li className='text-white fs-13'>Reality Tv Web Series</li>
                                                </>
                                            )}
                                        </>
                                    )}
                                </ul>
                                {openParent && (
                                    <span onClick={toggleExpandedfive} className="viewMore">
                                        {openFive ? 'View Less' : 'View All'} {openFive ? <IoChevronUp /> : <IoChevronDown />}
                                    </span>
                                )}
                            </Col>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">Shows by Language</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>Turkish TV</li>
                                    <li className='text-white fs-13'>Web Series</li>
                                    {openParent && (
                                        <>
                                            <li className='text-white fs-13'>Hindi Web Series</li>

                                            {openSix && (
                                                <>
                                                    <li className='text-white fs-13'>Tamil Web Series</li>
                                                    <li className='text-white fs-13'>Telugu Web Series</li>
                                                    <li className='text-white fs-13'>Korean Dramas</li>
                                                    <li className='text-white fs-13'>Mandarin Dramas</li>
                                                    <li className='text-white fs-13'>Dubbed Web Series</li>
                                                    <li className='text-white fs-13'>Bengali Web Series</li>
                                                </>
                                            )}
                                        </>
                                    )}
                                </ul>
                                {openParent && (
                                    <span onClick={toggleExpandedsix} className="viewMore">
                                        {openSix ? 'View Less' : 'View All'} {openSix ? <IoChevronUp /> : <IoChevronDown />}
                                    </span>
                                )}
                            </Col>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">Trending on Amazon MX</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>Gaming Insaan</li>
                                    <li className='text-white fs-13'>Gutar Gu</li>
                                    <li className='text-white fs-13'>Highway Love</li>
                                    <li className='text-white fs-13'>PlayGround Season 4</li>
                                    <li className='text-white fs-13'>Telugu Web Series</li>
                                    <li className='text-white fs-13'>Trailer</li>
                                </ul>
                            </Col>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">Popular Web Series</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>I'm Not A Robot</li>
                                    <li className='text-white fs-13'>The K2</li>
                                    <li className='text-white fs-13'>Bring It On, Ghost</li>
                                    <li className='text-white fs-13'>Goblin: The Lonely And Great God</li>
                                </ul>
                            </Col>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">Famous Movies in Hindi</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>Zombie Spring</li>
                                    <li className='text-white fs-13'>Breakers
                                        Snakes</li>
                                    <li className='text-white fs-13'>Kung Fu Killer in Hindi</li>
                                    <li className='text-white fs-13'>Horror Movies</li>
                                </ul>
                            </Col>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">New Shows on MX</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>Dehati Ladke</li>
                                    <li className='text-white fs-13'>Jamnapaar</li>
                                    <li className='text-white fs-13'>Slum Golf</li>
                                    <li className='text-white fs-13'>Flower of Evil</li>
                                </ul>
                            </Col>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">Popular Movies in Hindi</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>World Famous Lover</li>
                                    <li className='text-white fs-13'>Dear Comrade</li>
                                    <li className='text-white fs-13'>Aankh Micholi</li>
                                    <li className='text-white fs-13'>Dwaraka</li>
                                </ul>
                            </Col>
                            <Col md={2} className="mb-4">
                                <h5 class="categoryFooter">International Dramas</h5>
                                <ul className='footer_ul p-0 m-0'>
                                    <li className='text-white fs-13'>The Secret Weapon</li>
                                    <li className='text-white fs-13'>She Was Pretty</li>
                                    <li className='text-white fs-13'>DayDreamer</li>
                                    <li className='text-white fs-13'>Suspicious Partner</li>
                                </ul>
                            </Col>
                        </>
                    )}
                    <div className="text-center viewMore mb-2">
                        <span onClick={toggleExpandedParent}>{!openParent ? "Expand All" : "Collapse All"} {openParent ? <IoChevronUp /> : <IoChevronDown />}</span>
                    </div>
                </Row>
                <Row className="p-0">
                    <Col md={4} className="mb-1">
                        <div className="text-white p-2">
                            <h6 className="text-start fw-bold">Watch the Latest Movies in Regional Languages and TV Shows Online on MX Player...</h6>
                            {openParentTwo && (
                                <>
                                    <span className="text-start">
                                        {openSeven
                                            ? "If you are looking for the latest movies, most popular web shows, newly released songs as well as the latest news, then Galax OTT is your one-stop destination for all your entertainment needs. One of the best OTT platforms in India, Galax OTT is a free video streaming service that you can enjoy on your laptop, TV, mobile phone and other smart devices. You do not fight for the television remote anymore, as all your favourite TV channels live are streaming for free right here. From the best award-winning web shows and blockbuster movies to the latest music videos and daily TV shows, you name it and we have it for you. All you need to do is connect your smart device to the internet and let us do the rest. So you can now take the entertainment with you wherever you go."
                                            : "If you are looking for the latest movies, most popular web shows, newly released songs as well as the latest news,..."}
                                    </span>
                                    <div className="text-start viewMore" onClick={toggleReadMore}>
                                        {openSeven ? "Read Less" : "Read More"}
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                    <Col md={4} className="mb-1">
                        <div className="text-white p-2">
                            <h6 className="text-start fw-bold">Stream New Released TV Shows, Trailers for Free Online on MX Player...</h6>
                            {openParentTwo && (
                                <>
                                    <span className="text-start">
                                        {openEight
                                            ? "If you are looking for the latest movies, most popular web shows, newly released songs as well as the latest news, then Galax OTT is your one-stop destination for all your entertainment needs. One of the best OTT platforms in India, Galax OTT is a free video streaming service that you can enjoy on your laptop, TV, mobile phone and other smart devices. You do not fight for the television remote anymore, as all your favourite TV channels live are streaming for free right here. From the best award-winning web shows and blockbuster movies to the latest music videos and daily TV shows, you name it and we have it for you. All you need to do is connect your smart device to the internet and let us do the rest. So you can now take the entertainment with you wherever you go."
                                            : "If you are looking for the latest movies, most popular web shows, newly released songs as well as the latest news,..."}
                                    </span>

                                    <div className="text-start viewMore" onClick={toggleReadMoretwo}>
                                        {openEight ? "Read Less" : "Read More"}
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                    <Col md={4} className="mb-1">
                        <div className="text-white p-2">
                            <h6 className="text-start fw-bold">Catch unlimited Entertainment with Daily TV Show Episodes and New Web Shows Online...</h6>
                            {openParentTwo && (
                                <>
                                    <span className="text-start">
                                        {openNine
                                            ? "If you are looking for the latest movies, most popular web shows, newly released songs as well as the latest news, then Galax OTT is your one-stop destination for all your entertainment needs. One of the best OTT platforms in India, Galax OTT is a free video streaming service that you can enjoy on your laptop, TV, mobile phone and other smart devices. You do not fight for the television remote anymore, as all your favourite TV channels live are streaming for free right here. From the best award-winning web shows and blockbuster movies to the latest music videos and daily TV shows, you name it and we have it for you. All you need to do is connect your smart device to the internet and let us do the rest. So you can now take the entertainment with you wherever you go."
                                            : "If you are looking for the latest movies, most popular web shows, newly released songs as well as the latest news,..."}
                                    </span>
                                    <div className="text-start viewMore" onClick={toggleReadMorethree}>
                                        {openNine ? "Read Less" : "Read More"}
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                    <Col md={4} className="mb-1">
                        <div className="text-white p-2">
                            <h6 className="text-start fw-bold">Check out Movies, Shows and Much More on MX Player....</h6>
                            {openParentTwo && (
                                <>
                                    <span className="text-start">
                                        {openTen
                                            ? "Take delight of Trending: Hotspot eries, Pati Patni Aur Woh Series,  Crimes Aaj Kal, Namacool Bollywood music & movies, Tollywood entertainment, Tamil Songs, English movies, much-loved web series, shows and much more online whenever you want at MX Player."
                                            : "If you are looking for the latest movies, most popular web shows, newly released songs as well as the latest news,..."}
                                    </span>
                                    <div className="text-start viewMore" onClick={toggleReadMorefour}>
                                        {openTen ? "Read Less" : "Read More"}
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                    <div className="text-center viewMore mb-5">
                        <span onClick={toggleExpandedParenttwo}>{!openParentTwo ? "Expand All" : "Collapse All"} {openParentTwo ? <IoChevronUp /> : <IoChevronDown />}</span>
                    </div>
                </Row>
                <Row className="footer_card p-0">
                    <Col md={3}>
                        <div className="mb-2">
                            <h6 className="text-white mb-1 ">
                                Galax OTT
                            </h6>
                            <div className="text-white fs-10 mb-3">
                                Galax OTT is your one-stop destination for all your entertainment such as latest movies,
                                most popular web shows, Live TV channels, newly released songs etc
                            </div>
                            <div className="text-white hstack gap-2">
                                Follow For More Us.
                                <div className="gap-3">
                                    <FaFacebook className="text-white fs-15 ms-2" /> <RxInstagramLogo className="text-white fs-15 ms-2" /> <FaLinkedin className="text-white fs-15 ms-2" />
                                    <FaYoutube className="text-white fs-15 ms-2" /> <FaTwitter className="text-white fs-15 ms-2" />
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-start hstack mb-2">
                            <div className="mx-5">
                                <div className="text-white mb-1">Company</div>
                                <ul className="list-unstyled text-white">
                                    <li className="fs-13 mb-1">About Us</li>
                                    <li className="fs-13 mb-1">Careers</li>
                                    <li className="fs-13 mb-1">Advertise With Us</li>
                                    <li className="fs-13 mb-1">Contact Us</li>
                                    <li className="fs-13 mb-1">FAQ</li>
                                </ul>
                            </div>
                            <div>
                                <div className="text-white mb-1">Legal</div>
                                <ul className="list-unstyled text-white">
                                    <li className="fs-13 mb-1">Download Apps</li>
                                    <li className="fs-13 mb-1">Privacy Policy</li>
                                    <li className="fs-13 mb-1">Terms of Services</li>
                                    <li className="fs-13 mb-1">Contact Complaints</li>
                                    <li className="fs-13 mb-1">Compliance Report</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="mb-2">
                            <div className="fs-5 fw-bold text-white">
                                Install our Mobile App for Best Experience
                            </div>
                            <div className="mt-2 text-white">
                                <p className="mb-1">Open camera or any QR scanner app on your mobile.</p>
                                <p>Scan this QR code and you’ll be prompted with a download link.</p>
                            </div>
                            <div className="d-flex align-items-center mt-3">
                                <span className="text-white">App Available on</span>
                                <FaGooglePlay className="text-white ms-3 fs-14" />
                                <FaApple className="text-white ms-3 fs-14" />
                            </div>

                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="mb-2">
                            <img src={qrimage} alt="QR Code" style={{ width: '100%', height: '243px' }} />
                        </div>
                    </Col>
                    <div className="border-top mt-2">
                        <div className="hstack justify-content-between w-100 p-2">
                            <p className="text-white m-0">Galax OTT <span className="fs-10 text-white">© 2024 Galax OTT Media & Entertainment. All rights reserved.</span> </p>
                            <div className="text-white m-0">
                                <p className='m-0'>v1.0.0</p>
                            </div>

                        </div>

                    </div>

                </Row>



            </Container>
        </>
    )
}

export default Footer